import { MessageBundle } from "@amzn/arb-tools";

export const getHeaderCounterText = (
  itemsLength: number,
  selectedItemsLength: number
): string => {
  return selectedItemsLength > 0
    ? `(${selectedItemsLength}/${itemsLength})`
    : `(${itemsLength})`;
};

export const getTextFilterCounterText = (
  count: number,
  bundle: MessageBundle
) => {
  return bundle.formatMessage("filter_message", { numRecords: count });
};
